// Pure decision logic for useEnsureOfferApplied — extracted so the fresh-session
// regression class (2026-07-22, twice in one day) has direct unit coverage.

// Should the offer machinery run at all? Priority-cart flows and sessions
// without cart/student/school context skip entirely.
export function offerSkip({
  priorityCart, cartId, studentId, schoolId,
}) {
  return !!priorityCart || !cartId || !studentId || !schoolId;
}

// The offer's pricelist scope: the LAST order package in the SERVER-fetched
// cart (never localStorage context — that array is only populated for stale
// sessions, which is exactly the bug this guards against).
export function lastPackageIdOf(cart) {
  const ops = cart?.orderPackages;
  return ops && ops.length ? ops[ops.length - 1].packageId : undefined;
}

// Has the ensure-offer attempt settled enough to paint the summary?
//  - skipped entirely, or
//  - cart fetched and carries no package context (nothing to resolve), or
//  - offer resolution finished and there is no live offer, or
//  - the apply attempt completed (success OR settled failure).
export function offerSettled({
  skip, cartFetched, lastPackageId, offerFetched, offer, applied,
}) {
  if (skip) return true;
  if (cartFetched && !lastPackageId) return true;
  return !!(cartFetched && lastPackageId && offerFetched && (!offer || applied));
}
